import { render, staticRenderFns } from "./AddInquiryType.vue?vue&type=template&id=2cee9221&"
import script from "./AddInquiryType.vue?vue&type=script&lang=js&"
export * from "./AddInquiryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports